// Team Chat der Pille im iMessage-Stil – reine Darstellungsregeln (Handoff Pille §5, Screen 15).

export interface BlasenNachricht { id: string; absender_id: string; created_at: string }

export interface BlasenInfo {
  /** erste Nachricht einer Folge desselben Absenders (Name in Gruppen, Abstand davor) */
  ersteDerFolge: boolean;
  /** letzte einer Folge (Mini-Avatar in Gruppen) */
  letzteDerFolge: boolean;
  /** Tagestrenner („Heute“ …) vor dieser Nachricht */
  neuerTag: boolean;
  /** „Zugestellt“ unter der letzten eigenen Nachricht des Verlaufs */
  zugestellt: boolean;
}

const tagSchluessel = (iso: string) => new Date(iso).toDateString();

/** Gruppiert einen chronologischen Verlauf zu Blasenfolgen; ein Tageswechsel beginnt eine neue Folge. */
export function blasenInfos(verlauf: readonly BlasenNachricht[], meineId: string | null): BlasenInfo[] {
  let letzteEigene = -1;
  verlauf.forEach((n, i) => { if (n.absender_id === meineId) letzteEigene = i; });
  return verlauf.map((n, i) => {
    const vorher = verlauf[i - 1];
    const nachher = verlauf[i + 1];
    const neuerTag = !vorher || tagSchluessel(vorher.created_at) !== tagSchluessel(n.created_at);
    const naechsterNeuerTag = !nachher || tagSchluessel(nachher.created_at) !== tagSchluessel(n.created_at);
    return {
      ersteDerFolge: neuerTag || vorher?.absender_id !== n.absender_id,
      letzteDerFolge: naechsterNeuerTag || nachher?.absender_id !== n.absender_id,
      neuerTag,
      zugestellt: i === letzteEigene && i === verlauf.length - 1,
    };
  });
}

/** Vorschauzeile der Gesprächsliste: „Du: …“ bzw. in Gruppen „Anna: …“, sonst nur der Text. */
export function vorschauMitAbsender(text: string, eigen: boolean, gruppe: boolean, absenderName: string): string {
  if (eigen) return `Du: ${text}`;
  if (gruppe) return `${absenderName.split(/\s+/)[0] || absenderName}: ${text}`;
  return text;
}

const AVATAR_VERLAEUFE = [
  'linear-gradient(160deg,#ff9f0a,#d36b00)',
  'linear-gradient(160deg,#bf5af2,#7b2fbf)',
  'linear-gradient(160deg,#30d158,#1f8f3c)',
  'linear-gradient(160deg,#5ac8fa,#0a6fd8)',
] as const;

/** Fester Avatar-Verlauf je Name (gleicher Name → gleiche Farbe). */
export function avatarVerlauf(name: string): string {
  let h = 0;
  for (const z of name) h = (h * 31 + z.charCodeAt(0)) >>> 0;
  return AVATAR_VERLAEUFE[h % AVATAR_VERLAEUFE.length]!;
}
